import { Link } from 'react-router-dom';
import { STORE_LINKS } from '../brand.js';
import { PageShell } from '../components/PageShell.js';
import { Wordmark } from '../components/Wordmark.js';

export function HomePage() {
  return (
    <PageShell>
      <section className="mx-auto w-full max-w-3xl text-center">
        <p className="font-display text-xs font-normal uppercase tracking-brand text-kraft">
          Bringing India's living traditions to your home
        </p>
        <div className="mt-6">
          <Wordmark />
        </div>
        <h1 className="heading-xl mt-8 text-crimson">How was your FOIS experience?</h1>
        <p className="mt-5 text-lg leading-relaxed text-charcoal">
          Thank you for welcoming FESTIVALSOFINDIASTORE into your celebration. Your honest
          feedback helps us improve our products, packaging, and service.
        </p>
        <p className="mt-4 text-charcoal/80">
          If you received a feedback link or QR code with your order, open that unique page to share
          your thoughts. Honest feedback—positive or negative—is welcome. You do not need an
          account.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4">
          <Link className="btn-primary" to="/privacy">
            Read the privacy notice
          </Link>
          <a className="nav-link" href={STORE_LINKS.shopAll}>
            Continue shopping
          </a>
          <p className="text-sm text-charcoal/70">
            FOIS staff:{' '}
            <Link className="font-bold text-crimson underline" to="/admin/login">
              Administrator sign in
            </Link>
          </p>
        </div>
      </section>
    </PageShell>
  );
}
